export const LANG_SELECTED = 'local/LANG_SELECTED';
export const languageSelected = (payload: any) => ({ payload, type: LANG_SELECTED });
